import { cn } from "@/lib/cn";

interface StatProps {
  label: string;
  value: string | number;
  detail?: string;
  tone?: "neutral" | "warn";
}

/**
 * One typographic stat. Used inside <StatRow> with a divider between.
 */
export function Stat({ label, value, detail, tone = "neutral" }: StatProps) {
  return (
    <div className="flex-1 min-w-[160px]">
      <p className="label-eyebrow">{label}</p>
      <p
        className={cn(
          "mt-2 font-display text-2xl tracking-tight tabular-nums",
          tone === "warn" ? "text-gold-glow" : "text-fog",
        )}
      >
        {value}
      </p>
      {detail && <p className="mt-1 text-xs text-whisper">{detail}</p>}
    </div>
  );
}

/**
 * Editorial row of stats. No card, no icons — just a panel with dividers.
 */
export function StatRow({ children }: { children: React.ReactNode }) {
  return (
    <div className="panel p-6 flex flex-wrap divide-x divide-veil/40 [&>*]:px-5 [&>*:first-child]:pl-0 [&>*:last-child]:pr-0">
      {children}
    </div>
  );
}
